import constant from "../../../../constants/constant";
import { getGSTByRegion, isRegularGstStore } from "../../../../constants/utils";
import { ModifiedTableDataProps, ProductItemsProps } from "../interface"


export const useTableCalculation = () => {

    const modifiedTableData = ({
        data,
        isContactLens,
    }: ModifiedTableDataProps) => {
        let filterCondition = (items: ProductItemsProps) =>
            items?.product?.is_contact_lens === isContactLens;
        return data?.filter(filterCondition).length > 0
            ? [...data?.filter(filterCondition), {}]
            : [];
    };

    //calculate the gst
    const calculateGst=(row: ProductItemsProps):number=>{
        if(!row?.product?.product_type) return 0
        const initialCost = (row?.cost_amount - (row?.gst_amount/(row?.quantity || 1))) / (1 - (row?.discount_percent * 0.01));
        const cost_amount = initialCost || 0;
        const discountPercent = Number(row?.discount_percent) || 0;
        const discountAmount = cost_amount * discountPercent * 0.01;
        const gstRate = getGSTByRegion(row?.product?.product_type);
        let subTotalAmount =  (cost_amount - discountAmount) * (row?.quantity ?? 1);
       const gstAmount = (subTotalAmount * gstRate) / 100
        return gstAmount

    }
    //end

    //find the to add invoice is gst type or not
    const findInvoiceGstType = (item: any): boolean => {
        if(isRegularGstStore()){
            return item?.category === constant.INVOICE_CATEGORY[5].value && item?.gst_invoice
        }else{
            return item?.category === constant.INVOICE_CATEGORY[5].value && item?.non_gst_invoice
        }
    }
    //end

    // function to get the value
    const getTableValue = (row: ProductItemsProps, key: string, shouldAddGstInvoice:boolean) => {
        const initialCost = (row?.cost_amount - (row?.gst_amount/(row?.quantity || 1))) / (1 - (row?.discount_percent * 0.01));
        const cost = initialCost || 0;
        const discountPercent = Number(row?.discount_percent) || 0;

        const discountAmount = cost * discountPercent * 0.01;
        const amountAfterDiscount = Number(Number(cost) - Number(discountAmount)) * Number(row?.quantity);
        const totalGST: number = isRegularGstStore() ? Number(row?.gst_amount) :(shouldAddGstInvoice ? calculateGst(row) : 0);

        switch (key) {
            case "Unit Cost Amount":
                return initialCost;
            case "Discount Amount":
                return discountAmount.toFixed(2);

            case "Amount":
                return amountAfterDiscount.toFixed(2);

            case "Total GST":
                return totalGST.toFixed(2);

            case "Total Amount":
                return (amountAfterDiscount + totalGST).toFixed(2);

            default:
                return null;
        }
    };
    //end

    // to calculate the total
    const getTotalValue = (
        data: Array<any>,
        key: "Amount" | "Total GST" | "Total Amount",
        isContactLens: boolean,
        shouldAddGstInvoice:boolean
    ): string => {
        const modifiedData = modifiedTableData({ data, isContactLens });

        const total = modifiedData.reduce((sum: number, item: any) => {
            const initialCost = (item?.cost_amount - (item?.gst_amount/(item?.quantity || 1))) / (1 - (item?.discount_percent * 0.01));
            const discountAmount = initialCost * item?.discount_percent * 0.01
            const amountAfterDiscount = (item?.cost_amount - (item?.gst_amount/(item?.quantity || 1))) * item?.quantity;
            const totalGST: number = isRegularGstStore() ? item?.gst_amount :(shouldAddGstInvoice ? calculateGst(item) : 0);

            let value = 0;
            switch (key) {
                case "Amount":
                    value = amountAfterDiscount;
                    break;
                case "Total GST":
                    value = totalGST;
                    break;
                case "Total Amount":
                    value = amountAfterDiscount + totalGST;
                    break;
            }

            return sum + (isNaN(value) ? 0 : value);
        }, 0);

        return total.toFixed(2);
    };
    //end

    return {
        getTableValue,
        getTotalValue,
        modifiedTableData,
        findInvoiceGstType
    }
}; 